import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../button/button';
import { OdinIconSize } from '../../../odin-icon/odin-icon.component';

interface ClearFilterButtonProps {
  onClick: () => void;
}

const ClearFilterButton = ({ onClick }: ClearFilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <IconButton
      icon="CircleX"
      iconSize={OdinIconSize.ExtraSmall}
      classNames="odin-px-2 odin-flex odin-items-center odin-gap-2 odin-place-self-end odin-bg-transparent
        odin-rounded-md odin-border odin-border-transparent hover:odin-border-gray-1
        odin-duration-200 odin-transition-colors odin-text-sm"
      onClick={onClick}
      template={(_, icon) => (
        <>
          <p>{t('clear-filter', 'Clear filter')}</p>
          {icon}
        </>
      )}
    />
  );
};

export default ClearFilterButton;
